import React from 'react';
import PurchaseOrderViewInfoEntry from './PurchaseOrderViewInfoEntry';

import { Box, makeStyles } from '@material-ui/core';

import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';

import {
  CapaQuotationRfqPurchaseOrder,
  CapaQuotationRfqPurchaseOrderProvision,
  CapaRfqPurchaseOrderPaymentProvisionType
} from '@generated/graphql';

import { formatDate } from '@utils/formatter';

import useStyles from './useStyles';

interface Props {
  currentItem?: CapaQuotationRfqPurchaseOrder;
}

const PurchaseOrderPaymentInfo = ({ currentItem }: Props) => {
  const classes = useStyles();

  const payments = currentItem?.payments ?? [];

  const { payRoundList, payRound } = useDocumentsPaymentInfoStyles({
    numberOfProvision: payments?.length ?? 0
  });

  const PaymentEnumToString = (
    value: CapaQuotationRfqPurchaseOrderProvision
  ) => {
    switch (value.provisionType) {
      case CapaRfqPurchaseOrderPaymentProvisionType.AtContract:
        return '계약체결 시';
      case CapaRfqPurchaseOrderPaymentProvisionType.AfterShip:
        return '납품 직후';
      case CapaRfqPurchaseOrderPaymentProvisionType.AfterShipInspection:
        return '납품 및 검수 직후';
      case CapaRfqPurchaseOrderPaymentProvisionType.AtContractTermination:
        return '계약 종료 시';
      case CapaRfqPurchaseOrderPaymentProvisionType.Etc:
        return value.provisionEtc;
      default:
        return '기타';
    }
  };

  return (
    <div className={classes.wrapper + ' gutter'}>
      <CustomizedTypography variant="h4" fontWeight="500" gutterBottoms={8}>
        결제 정보
      </CustomizedTypography>

      <Box className={payRoundList}>
        {payments?.map((round, index, origin) => (
          <Box className={payRound} key={`${round.provisionDate}${index}`}>
            <CustomizedTypography
              className="roundTitle"
              variant="body2"
              color="textPrimary"
            >
              {origin.length === 1 ? '일괄결제' : `${index + 1}회차`}
            </CustomizedTypography>
            <PurchaseOrderViewInfoEntry
              label="구매확정일자"
              data={formatDate(
                round.provisionDate as string,
                'YYYY년 MM월 DD일'
              )}
            />
            <PurchaseOrderViewInfoEntry
              label="지급비율"
              data={`${round.provisionPercent}% (${(
                round.provisionCost ?? 0
              ).toLocaleString('kr')}원)`}
            />
            <PurchaseOrderViewInfoEntry
              label="지급조건"
              data={PaymentEnumToString(round)}
            />
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default PurchaseOrderPaymentInfo;

const useDocumentsPaymentInfoStyles = makeStyles((theme) => ({
  payRoundList: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      gap: '20px'
    }
  },
  payRound: {
    minWidth: (props: { numberOfProvision: number }) =>
      props.numberOfProvision === 1 ? '100%' : '268px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '& .roundTitle': {
      backgroundColor: colorSet.gray100,
      padding: '6px 8px',
      borderRadius: 8
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 'unset',
      width: '100%'
    }
  }
}));
